<template>
    <CompassTagInteractive
        :modelValue="type"
        class="listing-table-actions__filters-tag"
        color="blue"
        :keyLabel="`${label} : `"
        :valueLabel="valuesHumanized"
        @tag-remove="handleRemoveFilter"
        @click="handleClickOnTag"
    />
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        valuesHumanized: {
            type: String,
            required: true,
        },
    },
    methods: {
        handleClickOnTag() {
            this.$emit('clickOnTag');
        },
        handleRemoveFilter() {
            this.$emit('removeFilter');
        },
    },
};
</script>

<style lang="scss" scoped>
.listing-table-actions__filters-tag {
    cursor: pointer;
    :deep() {
        span:not(.compass-tag-interactive__key-label) {
            max-width: 180px;
            overflow-x: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
}
</style>
